import React from 'react';
import {
	Heading,
	Text,
	Image,
	VStack,
} from '@chakra-ui/react';

import { MotionBox } from 'Pages/LandingPage/BusinessSection/BusinessSection';
import { IImageSlider } from 'Types/Interface/ILandingPage';

interface IHowItWorksMobileProps{
	Carousels: IImageSlider[]
	isLoopBusiness: boolean;
}

export const HowItWorksMobile = ({Carousels, isLoopBusiness}:IHowItWorksMobileProps) => {
	return (
		<MotionBox
			drag="x"
			dragConstraints={{ right: 0, left: isLoopBusiness ? -922 : -622 }}
			display={'flex'}
		>
			{Carousels.map((Carousel, index) => {
				return (
					<MotionBox 
						w={['74vw', '48vw']} 
						mr={4} key={index} 
						border={'0.5px solid #cbcfd3'}
						borderRadius={'3px'}>
						<Image w={'xl'} src={Carousel.mobileSrc} />
						<VStack alignItems={'flex-start'} px={'6'} py={'8'} >
							<Heading fontSize={'xl'}>{Carousel.label}</Heading>
							<Text 
								w={'auto'}
								fontSize={'sm'}
								lineHeight={'28px'}
								color={'#586068'}
							>
								{Carousel.text}
							</Text>
						</VStack>
					</MotionBox>
				);
			})}
		</MotionBox>
	);
};
